import crypto from "node:crypto";
import {MetaFunction, Form, useActionData, ActionFunctionArgs, Link, useParams} from "react-router";

import {Paper, Title, TextInput, Button, Image, Group, Text} from "@mantine/core";
import {CsrfToken} from "@digisthesia/remix-utils/csrf-token";
import {safeFormData} from "@digisthesia/remix-utils/helpers.server";

import {User} from "~gen/entities";

import config from "~/config.server";
import {ResetPasswordMail} from "~/mails.server";
import {resolveLocaleFromRequest} from "~/strings/global";
import {getLangPrefix} from "~/routes/route-helpers";
import {sendMail} from "~/utils.server";

export async function action({request}: ActionFunctionArgs) {
  const formData = await safeFormData({request});
  const locale = resolveLocaleFromRequest(request);
  const email = formData.get("email") as string;
  const user = await User.query().findOne({email});
  if (user) {
    const passwordChangeToken = crypto.randomBytes(16).toString("hex");
    const passwordChangeCode = crypto
      .createHmac("sha256", config.secretToken)
      .update(passwordChangeToken)
      .digest("hex");
    await user.$query().patch({passwordChangeToken});
    await sendMail(
      user.email,
      "Reset your password",
      <ResetPasswordMail
        email={user.email}
        passwordChangeCode={passwordChangeCode}
        origin={config.appUrl}
        locale={locale}
      />,
    );
  }
  return {email, message: "Vous allez recevoir un email contenant le lien pour changer votre mot de passe"};
}

export default function ForgotPassword() {
  const {email, message} = useActionData<typeof action>() ?? {};
  const {lang} = useParams();
  const langPrefix = getLangPrefix(lang);
  return (
    <div className="login-wrapper">
      <Paper className="login-form">
        <Image mx="auto" w={200} src="http://static.digisthesia.com/hexploit/images/logo_hexploit_500.webp" />
        <Title order={2} ta="center">
          Mot de passe oublié
        </Title>
        <Text mb={30} ta="center">
          Renseignez l'email lié à votre compte.
        </Text>
        <Form method="POST">
          <CsrfToken />
          {message && (
            <Text mb={30} c="green">
              {message}
            </Text>
          )}

          <TextInput
            defaultValue={email}
            label="Email"
            id="email"
            name="email"
            type="email"
            placeholder="email@addresse.com"
            size="md"
            radius="md"
          />
          <Group grow>
            <Button
              variant="light"
              color="white"
              component={Link}
              to={`${langPrefix}/login`}
              mt="xl"
              size="md"
              radius="md"
            >
              Annuler
            </Button>
            <Button mt="xl" size="md" radius="md" type="submit">
              Envoyer
            </Button>
          </Group>
        </Form>
      </Paper>
    </div>
  );
}

export const meta: MetaFunction = () => [{title: "Hexploit - Mot de passe oublié"}];
